module.exports = __webpack_public_path__ + "552f6edf84813ccf4c3db4270c2f97dd.MP3";